import { Button, Form, Table } from "antd";
import { inpatientService } from "api";
import { ListActionButton } from "components/common";
import {
  convertIosStringToDate,
  formatDateToString,
  formatToCurrencyType,
} from "helper/common";
import React, { useEffect, useRef, useState } from "react";
import { FORMAT_TIME } from "types/enums";
import { ColumnTypes } from "types/models/column-table-edit";
import ServiceTable from "../TreatmentSheet/Services/Services";
import { Notification } from "components/common";
import dayjs from "dayjs";
const PhuThuModal = (props) => {
  const { idPhieuKham, thongTinDieuTri } = props;
  console.log("🚀 ~ PhuThuModal ~ idPhieuKham:", idPhieuKham);
  const [data, setData] = useState<any[]>();
  const sRef = useRef<any>();
  const [form] = Form.useForm();
  const [idToDieuTri, setIdToDieuTri] = useState();
  const columnsInit = [
    {
      title: "STT",
      key: "stt",
      align: "center",
      render: (v, r, i) => i + 1,
    },
    {
      title: "Mã dịch vụ",
      key: "maDichVu",
      align: "center",
      dataIndex: "maDichVu",
    },
    {
      title: "Tên dịch vụ",
      key: "tenChiDinh",
      align: "left",
      dataIndex: "tenChiDinh",
    },
    {
      title: "Đơn giá",
      key: "donGia",
      align: "right",
      dataIndex: "donGia",
      render: (v, r, i) => {
        return <>{formatToCurrencyType(v)}</>;
      },
    },
    //  {
    //    title: "Đơn giá BHYT",
    //    key: "baoHiemTra",
    //    align: "right",
    //    dataIndex: "baoHiemTra",
    //    render: (v, r, i) => {
    //      return <>{formatToCurrencyType(v)}</>;
    //    },
    //  },
    {
      title: "Ngày chỉ định",
      key: "thoiGian",
      align: "center",
      dataIndex: "thoiGian",
      render: (value, record, index) => {
        return <>{formatDateToString(value, FORMAT_TIME.dateTime)}</>;
      },
    },

    {
      title: "Số lượng",
      key: "soLuong",
      align: "right",
      dataIndex: "soLuong",
    },
    {
      title: "Thao tác",
      key: "action",
      align: "center",
      render: (value, record, index) => {
        return (
          <ListActionButton
            deleteFunction={() => {
              deletePhuThu(record?.id);
            }}
          ></ListActionButton>
        );
      },
    },
  ];

  useEffect(() => {
    const getLatestToDieuTriId = () => {
      const listToDieuTri = thongTinDieuTri?.toDieuTriDtoList.sort(
        (a: any, b: any) =>
          convertIosStringToDate(JSON.parse(a?.toDieuTri ?? "{}")?.lanSuaCuoi) >
          convertIosStringToDate(JSON.parse(b?.toDieuTri ?? "{}")?.lanSuaCuoi)
      );
      setIdToDieuTri(listToDieuTri?.[0]?.id);
    };
    getLatestToDieuTriId();
  }, [thongTinDieuTri]);
  const handleServiceSave = async () => {
    let dvs = sRef.current?.getData();
    try {
      if (!dvs || dvs.length === 0) {
        Notification("warning", "Chưa có dịch vụ được thêm!");
        return;
      }
      let dt = {
        idToDieuTri: idToDieuTri,
        ngayTaoPhieu: dayjs().format(),
        idPhieuKham: idPhieuKham,
        bacSyChiDinh: localStorage.getItem("fullName"),
        chiDinhDtos: dvs.map((it) => ({
          tenChiDinh: it.tenDichVu,
          baoHiemTra: it.bhChiTra,
          maDichVu: it.id,
          thoiGian: dayjs().format(),
          donGia: it.donGia,
          soLuong: 1,
          thanhTien: it.soLuong * it.donGia,
          coBaoHiem: it.coBaoHiem,
          canTuVan: it.canTuVan,
          ghiChu: it.ghiChu,
          trangThai: 0,
          trangThaiThanhToan: 0,
          hienThiBangKe: it.hienThiBangKe === false ? false : true,
        })),
      };
      await inpatientService.postPhieuChiDinh(dt);
      getListPhuThu();
      Notification("success", "Lưu thành công");
    } catch (err) {
      Notification("error", "Thêm dịch vụ không thành công");
    }
  };
  const deletePhuThu = async (id) => {
    try {
      await inpatientService.deleteChiDinh(id);
      const _data = data.filter((e) => e?.id != id);
      setData(_data);
    } catch (error) {}
  };
  const getListPhuThu = async () => {
    try {
      const res = await inpatientService.getListPhuThu(idPhieuKham);
      setData(res?.chiDinhDtos);
    } catch (error) {
      setData([]);
    }
  };
  const onAddService = () => {
    sRef.current?.setSelectedServices([]);
    sRef.current?.openModal();
    // if (
    //   form.getFieldValue(["table", "row0", "ngay"]) &&
    //   form.getFieldValue(["table", "row0", "gio"])
    // ) {
    //   sRef.current?.setSelectedServices([]);
    //   sRef.current?.openModal();
    // } else {
    //   Notification("warning", "Hãy thêm ngày giờ!");
    //   return;
    // }
  };
  useEffect(() => {
    getListPhuThu();
  }, [idPhieuKham]);
  return (
    <div>
      <Button onClick={onAddService}>Thêm phụ thu</Button>
      <Table dataSource={data} columns={columnsInit as ColumnTypes}></Table>
      <Form>
        <ServiceTable ref={sRef} onSave={handleServiceSave} />
      </Form>
    </div>
  );
};
export default PhuThuModal;
